/** Backend API base URL (set REACT_APP_BACKEND_URL at build time for production). */
export const BACKEND_BASE =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:3002";

export function backendUrl(path) {
  const base = BACKEND_BASE.replace(/\/$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}
